import React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { isLogged } from '@food/auth/build/dist/logic/auth';
import { UserData, UserDataInterface } from '@food/auth/build/dist/components/UserData';
import {
	AbbonamentoEdge,
	Abbonamento,
} from '../server-types';
import * as Sentry from '@sentry/browser';

export type TUserExtendedData = UserDataInterface['userData'] & {
	abbonamenti: ReadonlyArray<Pick<Abbonamento, 'id' | 'Fine' | 'Giorni_alla_scadenza'>>;
};

interface IUserExtendedDataProps {
	children: (
		loading: boolean,
		extendedUserData: TUserExtendedData | null,
	) => JSX.Element;
}

export const additionalUserDataQuery = gql`
	query AdditionalUserDataQuery {
		abbonamenti(filter: { isActive: true, referenteIsCurrentUser: true }) {
			edges {
				node {
					id
					Fine
					Giorni_alla_scadenza
				}
			}
		}
	}
`;

const UserExtendedData: React.FC<IUserExtendedDataProps> = ({ children }) => (
	<UserData>
		{({ loading, userData }) => {
			if (!isLogged()) {
				return children(false, null);
			}
			if (loading) {
				return children(true, null);
			}
			return (
				<Query<any> query={additionalUserDataQuery} errorPolicy="all">
					{({ loading, error, data }) => {
						if (loading) {
							return children(true, null);
						}

						if (error) {
							Sentry.captureException(error);
							console.error('GraphQL Error in UserExtendedData:', error);

							if (userData) {
								return children(false, {
									...userData,
									abbonamenti: [],
								});
							}

							return children(false, null);
						}

						if (!userData) {
							Sentry.captureMessage('UserExtendedData: userData is null but abbonamenti received');
							return children(false, null);
						}

						const abbonamenti =
							data?.abbonamenti?.edges?.map((edge: AbbonamentoEdge) => edge.node) || [];

						return children(false, {
							...userData,
							abbonamenti,
						});
					}}
				</Query>
			);
		}}
	</UserData>
);

export { UserExtendedData };
